<template>
  <Layout> <RouterView /> </Layout>
</template>

<script>
import PageHeader from "../page-header";
import Layout from "./main";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Tunesoft",
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Client",
    };
  },
  mounted() {},
};
</script>
